var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 258.799,
    height: 46.903,
    viewBox: "0 0 258.799 46.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PROY_APUESTES_BrandPack_01",
    transform: "translate(-35.95 -33.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1447",
    "data-name": "Trazado 1447",
    d: "M89.5,43.573a.255.255,0,0,1,0-.05A10.039,10.039,0,1,1,99.536,53.6h-.02A10.039,10.039,0,0,1,89.5,43.623a.306.306,0,0,1,0-.05Zm-26.779,0A10.038,10.038,0,1,1,82.8,43.455h0v.235h0A16.713,16.713,0,0,0,99.224,60.3h.642A10.035,10.035,0,1,1,89.514,70.382c0-.02,0-.155,0-.175a16.68,16.68,0,0,0-3.361-9.945A16.958,16.958,0,0,0,82.9,56.989a.447.447,0,0,1-.064-.047,16.666,16.666,0,0,0-9.746-3.361h-.625a16.686,16.686,0,0,0-9.746,3.361,16.868,16.868,0,0,0-3.324,3.331,16.683,16.683,0,0,0-3.361,10.052h0A10.042,10.042,0,1,1,45.676,60.3h.635a16.666,16.666,0,0,0,9.746-3.361,16.885,16.885,0,0,0,3.327-3.331,16.693,16.693,0,0,0,3.361-10.049h0",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1448",
    "data-name": "Trazado 1448",
    d: "M290.33,66.983A9.854,9.854,0,0,1,299.892,56.8a8.442,8.442,0,0,1,6.3,2.524V57.2H312.4V76.639h-6.218V74.384A8.1,8.1,0,0,1,300,77.025,9.832,9.832,0,0,1,290.33,66.983Zm6.026-.034a4.925,4.925,0,1,0,9.834,0,4.927,4.927,0,1,0-9.834,0Z",
    transform: "translate(-168.888 -15.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1449",
    "data-name": "Trazado 1449",
    d: "M374.038,57.236v2.178a8.451,8.451,0,0,1,6.295-2.564c5.172,0,9.562,4.393,9.562,10.183a9.805,9.805,0,0,1-9.676,10.025,8.234,8.234,0,0,1-6.18-2.642V84.446H367.82V57.236Zm4.934,14.949a5.217,5.217,0,0,0,0-10.415,5.052,5.052,0,0,0-4.934,5.213A5,5,0,0,0,378.971,72.185Z",
    transform: "translate(-220.335 -15.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1450",
    "data-name": "Trazado 1450",
    d: "M442.87,68.361V58h6.217v9.817c0,2.877,1.516,4.742,4.033,4.742,2.759,0,4.393-2.215,4.393-5.041V58h6.238V77.436h-6.217V75.241a7.633,7.633,0,0,1-5.986,2.645C446.406,77.886,442.87,74.5,442.87,68.361Z",
    transform: "translate(-270.162 -16.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1451",
    "data-name": "Trazado 1451",
    d: "M525.565,56.57c6.957,0,10.5,5.092,10.183,11.269h-14.3a4.7,4.7,0,0,0,4.742,4.393,5.535,5.535,0,0,0,4.9-2.487l3.734,2.6c-1.344,2.292-4.51,4.588-9.135,4.588-6.258,0-10.533-4.51-10.533-10.183S518.958,56.57,525.565,56.57Zm4.588,7.811A3.881,3.881,0,0,0,526.069,61a4.369,4.369,0,0,0-4.43,3.381Z",
    transform: "translate(-318.15 -15.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1452",
    "data-name": "Trazado 1452",
    d: "M584.823,70.87a10.037,10.037,0,0,0,5.985,1.6c1.344,0,2.527-.622,2.527-1.516,0-2.759-10.536-2.218-10.536-8.476,0-3.7,3.3-5.9,8.436-5.9a13.506,13.506,0,0,1,7.461,1.865L596.6,62.4a9.662,9.662,0,0,0-5.132-1.4c-1.008,0-2.564.232-2.564,1.344,0,2.527,10.65,2.292,10.65,8.55,0,3.771-3.539,6.026-8.785,6.026-5.169,0-7.394-1.633-8.318-2.3Z",
    transform: "translate(-362.832 -15.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1453",
    "data-name": "Trazado 1453",
    d: "M638.77,52.984V48.141h2.645V43.15h6.218v4.991h4.47v4.843h-4.47V60.6c0,1.711.427,2.6,1.865,2.6a7.478,7.478,0,0,0,2.373-.43l1.166,4.393a13.731,13.731,0,0,1-4.937.817c-5.287,0-6.685-2.991-6.685-7.347V52.984Z",
    transform: "translate(-400.224 -6.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1454",
    "data-name": "Trazado 1454",
    d: "M698.219,56.57c6.957,0,10.492,5.092,10.183,11.269H694.1a4.7,4.7,0,0,0,4.742,4.393,5.535,5.535,0,0,0,4.9-2.487l3.73,2.6c-1.344,2.292-4.507,4.588-9.131,4.588-6.258,0-10.536-4.51-10.536-10.183S691.611,56.57,698.219,56.57Zm4.588,7.811A3.885,3.885,0,0,0,698.723,61a4.369,4.369,0,0,0-4.43,3.381Z",
    transform: "translate(-432.776 -15.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1455",
    "data-name": "Trazado 1455",
    d: "M757.483,70.87a10.03,10.03,0,0,0,5.986,1.6c1.344,0,2.524-.622,2.524-1.516,0-2.759-10.533-2.218-10.533-8.476,0-3.7,3.3-5.9,8.436-5.9a13.516,13.516,0,0,1,7.461,1.865l-2.1,3.962a9.662,9.662,0,0,0-5.132-1.4c-1.008,0-2.564.232-2.564,1.344,0,2.527,10.65,2.292,10.65,8.55,0,3.771-3.539,6.026-8.785,6.026-5.169,0-7.394-1.633-8.318-2.3Z",
    transform: "translate(-477.464 -15.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1456",
    "data-name": "Trazado 1456",
    d: "M517.2,138.86h3.317a2.18,2.18,0,0,1,2.326,2.524,3.025,3.025,0,0,1-3.025,2.524h-2.457l-.43,3.1h-.871Zm.766.756-.5,3.536h2.225a2.047,2.047,0,0,0,2.279-1.768c.165-1.129-.511-1.768-1.778-1.768Z",
    transform: "translate(-318.754 -69.967)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1457",
    "data-name": "Trazado 1457",
    d: "M537.615,148.452a3.579,3.579,0,0,1,3.455-3.025,2.558,2.558,0,0,1,2.6,3.025,3.583,3.583,0,0,1-3.455,3.025,2.557,2.557,0,0,1-2.6-3.025Zm2.689,2.329a2.726,2.726,0,0,0,2.534-2.329,1.938,1.938,0,0,0-1.882-2.326,2.732,2.732,0,0,0-2.537,2.326,1.95,1.95,0,0,0,1.9,2.329Z",
    transform: "translate(-333.036 -74.326)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1458",
    "data-name": "Trazado 1458",
    d: "M560.667,145.78l1.092,4.705,2.41-4.705h.894l1.1,4.705,2.406-4.705h.9l-3.048,5.818h-.827l-1.129-4.655-2.443,4.655H561.2l-1.418-5.818Z",
    transform: "translate(-347.781 -74.561)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1459",
    "data-name": "Trazado 1459",
    d: "M593.745,145.43c1.815,0,2.789,1.257,2.463,3.166H591.08a1.862,1.862,0,0,0,1.848,2.188,2.6,2.6,0,0,0,2.131-1.106l.591.336a3.307,3.307,0,0,1-2.826,1.479,2.529,2.529,0,0,1-2.524-3.025A3.553,3.553,0,0,1,593.745,145.43Zm1.707,2.467a1.64,1.64,0,0,0-1.791-1.768,2.537,2.537,0,0,0-2.43,1.768Z",
    transform: "translate(-368.023 -74.329)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1460",
    "data-name": "Trazado 1460",
    d: "M613.627,145.548l-.128.921a3.216,3.216,0,0,1,2.353-1.038,4.618,4.618,0,0,1,.568.047l-.3.756a2.016,2.016,0,0,0-.383-.034,2.437,2.437,0,0,0-2.49,2.07l-.43,3.1H612l.813-5.818Z",
    transform: "translate(-382.451 -74.329)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1461",
    "data-name": "Trazado 1461",
    d: "M633.955,145.78h.894l1.9,4.853,2.588-4.853h.894l-3.62,6.644a2.736,2.736,0,0,1-2.373,1.617,2.047,2.047,0,0,1-1.314-.477l.336-.581a1.778,1.778,0,0,0,1.035.373,1.915,1.915,0,0,0,1.64-1.2l.3-.548Z",
    transform: "translate(-396.339 -74.561)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1462",
    "data-name": "Trazado 1462",
    d: "M655.916,148.452a3.583,3.583,0,0,1,3.455-3.025,2.558,2.558,0,0,1,2.6,3.025,3.583,3.583,0,0,1-3.455,3.025,2.561,2.561,0,0,1-2.6-3.025Zm2.689,2.329a2.722,2.722,0,0,0,2.537-2.329,1.944,1.944,0,0,0-1.885-2.326,2.729,2.729,0,0,0-2.537,2.326,1.959,1.959,0,0,0,1.909,2.329Z",
    transform: "translate(-411.579 -74.326)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1463",
    "data-name": "Trazado 1463",
    d: "M678.733,148.98l.444-3.2h.813l-.444,3.2c-.175,1.243.386,2.037,1.512,2.037a2.383,2.383,0,0,0,2.329-2.094l.44-3.142h.817l-.81,5.818h-.813l.128-.931a2.689,2.689,0,0,1-2.174,1.049C679.267,151.715,678.487,150.657,678.733,148.98Z",
    transform: "translate(-426.726 -74.561)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1464",
    "data-name": "Trazado 1464",
    d: "M701.847,145.548l-.128.921a3.216,3.216,0,0,1,2.353-1.038,4.619,4.619,0,0,1,.568.047l-.3.756a2.017,2.017,0,0,0-.383-.034,2.437,2.437,0,0,0-2.49,2.07l-.43,3.1h-.813l.813-5.818Z",
    transform: "translate(-441.022 -74.329)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1465",
    "data-name": "Trazado 1465",
    d: "M723.644,148.452a3.579,3.579,0,0,1,3.455-3.025,2.558,2.558,0,0,1,2.6,3.025,3.586,3.586,0,0,1-3.455,3.025,2.558,2.558,0,0,1-2.6-3.025Zm2.689,2.329a2.726,2.726,0,0,0,2.534-2.329,1.938,1.938,0,0,0-1.882-2.326,2.732,2.732,0,0,0-2.537,2.326,1.95,1.95,0,0,0,1.9,2.329Z",
    transform: "translate(-456.545 -74.326)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1466",
    "data-name": "Trazado 1466",
    d: "M745.86,144.063a3.572,3.572,0,0,1,3.455-3.025,2.269,2.269,0,0,1,2.06,1.1l.464-3.3h.817l-1.143,8.143H750.7l.128-.988a3.106,3.106,0,0,1-2.373,1.106A2.549,2.549,0,0,1,745.86,144.063Zm2.689,2.353a2.748,2.748,0,0,0,2.537-2.353,1.924,1.924,0,0,0-1.885-2.316,2.739,2.739,0,0,0-2.537,2.316,1.964,1.964,0,0,0,1.912,2.339Z",
    transform: "translate(-471.303 -69.947)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1467",
    "data-name": "Trazado 1467",
    d: "M769.061,144.063a3.572,3.572,0,0,1,3.455-3.025,2.269,2.269,0,0,1,2.06,1.1l.464-3.3h.817l-1.133,8.153h-.813l.128-.988a3.105,3.105,0,0,1-2.373,1.106,2.561,2.561,0,0,1-2.6-3.038Zm2.689,2.353a2.745,2.745,0,0,0,2.537-2.353,1.924,1.924,0,0,0-1.885-2.316,2.739,2.739,0,0,0-2.537,2.316,1.961,1.961,0,0,0,1.9,2.339Z",
    transform: "translate(-486.696 -69.947)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1468",
    "data-name": "Trazado 1468",
    d: "M791.384,150.189a2.209,2.209,0,0,0,1.68.595c.87,0,1.559-.373,1.64-.931.175-1.267-3.583-.837-3.294-2.9.141-.978,1.082-1.526,2.457-1.526a2.973,2.973,0,0,1,1.943.538l-.42.6a2.567,2.567,0,0,0-1.489-.444c-.534,0-1.57.1-1.68.827-.185,1.371,3.573.884,3.294,2.873-.138,1.008-1.116,1.654-2.581,1.654a2.739,2.739,0,0,1-2.074-.672Z",
    transform: "translate(-501.199 -74.329)",
    fill: "#e73758"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.df755ca403cccfbaf5338f941e7ac360.svg";
export { ForwardRef as ReactComponent };